<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  services: { type: Array, default: () => [] },
});

const { t } = useI18n();
const serviceType = service =>
  service.tipo_servico?.name || service.servico_detalhado?.name || service.nome;
const latestMessage = service =>
  [...(service.historico || [])].reverse().find(event => event.message)
    ?.message;
const nucleoNotes = computed(() =>
  props.services
    .map(service => ({
      id: service.id,
      message: latestMessage(service),
      type: serviceType(service),
    }))
    .filter(note => note.message)
);
const postSaleNotes = computed(() =>
  props.services
    .map(service => ({
      id: service.id,
      message: service.descricao,
      type: serviceType(service),
    }))
    .filter(note => note.message)
);
</script>

<template>
  <div class="grid gap-4 lg:grid-cols-2">
    <section
      data-test="nucleo-notes"
      class="rounded-lais border border-lais-border-soft bg-white p-5"
    >
      <h3 class="font-semibold text-lais-text">
        {{ t('SALES.DETAIL.NUCLEO.NUCLEO_NOTES') }}
      </h3>
      <div v-for="note in nucleoNotes" :key="note.id" class="mt-3 text-sm">
        <span
          v-if="note.type"
          class="mr-2 rounded-full bg-lais-bg-soft px-2 py-1 text-xs font-semibold text-lais-text-body"
        >
          {{ note.type }}
        </span>
        <span class="text-lais-text-body">{{ note.message }}</span>
      </div>
    </section>
    <section
      data-test="post-sale-notes"
      class="rounded-lais border border-lais-border-soft bg-white p-5"
    >
      <h3 class="font-semibold text-lais-text">
        {{ t('SALES.DETAIL.NUCLEO.POST_SALE_NOTES') }}
      </h3>
      <div v-for="note in postSaleNotes" :key="note.id" class="mt-3 text-sm">
        <span
          v-if="note.type"
          class="mr-2 rounded-full bg-lais-bg-soft px-2 py-1 text-xs font-semibold text-lais-text-body"
        >
          {{ note.type }}
        </span>
        <span class="text-lais-text-body">{{ note.message }}</span>
      </div>
    </section>
  </div>
</template>
